import classNames from "classnames";
import { Button, Col, IconButton } from "components/primitives";
import { WidgetControlClass } from "components/WidgetComponents";
import styled from "styled-components";

export const Container = styled(Col)`
  height: 100%;
  padding: 5cqh 5cqw;

  div:has(textarea) {
    height: 70cqh;

    textarea {
      font-size: 3.5cqh;
      height: calc(100% - 8cqh);

      + div > span {
        font-size: 3.5cqh;
      }
    }
  }
`;

export const Title = styled("h2")`
  color: var(--widget-primary);
  text-align: center;
  margin-bottom: 1.5rem;
  font-size: 4cqw;
`;

export const EmbedButton = styled(Button)<{ color: string }>`
  background-color: ${(props) => props.color};
  color: black;
  width: 80cqw;
  height: 10cqh;
  font-size: 3cqw;
  margin: 1cqh auto 0;
  box-shadow: none;
`;

export const VideoContainer = styled("div")`
  background-color: black;
  height: 100%;

  iframe {
    left: 0;
    top: 2.5%;
    height: 95%;
    width: 100%;
    position: absolute;
    border: none;
  }
`;

export const MoveIconBtn = styled(IconButton).attrs({
  className: classNames(WidgetControlClass),
})`
  cursor: move !important;
  position: absolute;
  width: var(--widget-handle-size);
  height: var(--widget-handle-size);
  right: calc(var(--widget-handle-size) / -2 + (var(--widget-handle-size) * 1.5));
  bottom: calc(var(--widget-handle-size) / -2);
`;
